export const TOGGLE_FORM = 'TOGGLE_FORM'

export const toggleForm = () => ({
    type: TOGGLE_FORM,
    payload: {}
  });